class FetchOrganizationWorkflows {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchOrganizationWorkflows;
